import React, { useRef, useState } from 'react';
import { ImagePlus, X } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { logoFileToDataUrl } from '../lib/vendorLogo';

/** Logo picker for the vendor dialogs. `value` is a data URL or ''. */
export default function VendorLogoField({ id, value, onChange }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setBusy(true);
    try {
      onChange(await logoFileToDataUrl(file));
    } catch (err) {
      toast.error(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <Label htmlFor={id}>Logo (printed on invoices)</Label>
      <div className="mt-1 flex items-center gap-3">
        <div className="flex h-14 w-28 items-center justify-center rounded-md border border-dashed border-gray-300 bg-white">
          {value
            ? <img src={value} alt="Vendor logo" className="max-h-12 max-w-[6.5rem] object-contain" />
            : <span className="text-xs text-gray-400">No logo</span>}
        </div>
        <input id={id} ref={inputRef} type="file" accept="image/*" className="hidden" onChange={pick} />
        <Button type="button" variant="outline" disabled={busy} onClick={() => inputRef.current?.click()} className="gap-2">
          <ImagePlus size={15} />
          {busy ? 'Processing…' : value ? 'Replace' : 'Upload'}
        </Button>
        {value && (
          <Button type="button" variant="ghost" onClick={() => onChange('')} className="gap-1 text-gray-500">
            <X size={15} /> Remove
          </Button>
        )}
      </div>
    </div>
  );
}
